module.exports = __webpack_public_path__ + "img/png.68e1ce33.svg";